export default function Eye({ size = 24, fill = "#fff" }) {
  return (
    <svg
      id="eye-Regular"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <rect id="Path" width="24" height="24" fill="rgba(255,255,255,0)" />
      <path
        id="eye-Regular_1_"
        d="M368.229,1020.115c-1.315-2.19-4.263-5.866-9.229-5.866s-7.914,3.675-9.229,5.866a3.656,3.656,0,0,0,0,3.768c1.316,2.19,4.264,5.866,9.229,5.866s7.914-3.675,9.229-5.866h0A3.652,3.652,0,0,0,368.229,1020.115Zm-1.286,3c-1.152,1.919-3.716,5.138-7.943,5.138s-6.791-3.219-7.943-5.138a2.16,2.16,0,0,1,0-2.224c1.152-1.919,3.717-5.138,7.943-5.138s6.792,3.219,7.943,5.138A2.155,2.155,0,0,1,366.943,1023.112ZM359,1017.75a4.25,4.25,0,1,0,4.25,4.25A4.255,4.255,0,0,0,359,1017.75Zm0,7a2.75,2.75,0,1,1,2.75-2.75A2.752,2.752,0,0,1,359,1024.75Z"
        transform="translate(-347 -1010)"
        fill={fill}
      />
    </svg>
  );
}
